var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info Circle - 1 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bulk/Info-Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    opacity: 0.4,
    d: "M14.6663 8.03776C14.6663 11.7204 11.6817 14.7044 7.99967 14.7044C4.31767 14.7044 1.33301 11.7204 1.33301 8.03776C1.33301 4.35643 4.31767 1.37109 7.99967 1.37109C11.6817 1.37109 14.6663 4.35643 14.6663 8.03776Z",
    fill: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M7.99642 9.99058C8.32509 9.99058 8.58642 10.2526 8.58642 10.5739C8.58642 10.8952 8.32509 11.1572 8.00309 11.1572C7.67975 11.1572 7.41642 10.8952 7.41642 10.5739C7.41642 10.2526 7.67709 9.99058 7.99642 9.99058ZM7.99642 4.92871C8.31775 4.92871 8.57975 5.19071 8.57975 5.51204V8.45871C8.57975 8.78004 8.31775 9.04204 7.99642 9.04204C7.67509 9.04204 7.41309 8.78004 7.41309 8.45871V5.51204C7.41309 5.19071 7.67509 4.92871 7.99642 4.92871Z",
    fill: "#6B6B6B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle11);
export default __webpack_public_path__ + "static/media/info-circle-11.50287f32365802f15363002ea4534ed5.svg";
export { ForwardRef as ReactComponent };